// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title-image {
  height: auto;
  width: 1000px;
}

.form-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.player-name-input {
  margin-top: 100px;
  font-family: inherit;
  width: 100%;
  border: 0;
  border-bottom: 2px solid gray;
  outline: 0;
  font-size: 2rem;
  color: black;
  padding: 7px 0;
  background: transparent;
  transition: border-color 0.2s;
}
.player-name-input::placeholder {
  color: black;
}
.player-name-input:placeholder-shown ~ .player-name-label {
  font-size: 1.3rem;
  cursor: text;
  top: 20px;
}

.player-name-input:focus {
  padding-bottom: 6px;
  font-weight: 700;
  border-width: 3px;
  border-image: linear-gradient(to right, primary, secondary);
  border-image-slice: 1;
}
.player-name-input:focus ~ .player-name-label {
  position: absolute;
  top: 0;
  display: block;
  transition: 0.2s;
  font-size: 1rem;
  color: primary;
  font-weight: 700;
}

.player-name-input:required, .player-name-input:invalid {
  box-shadow: none;
}

body {
  font-family: "Poppins", sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  font-size: 1.5rem;
  background-color: white;
}

.player-name-button {
  width: 50px;
}

.display {
  background: linear-gradient(to right, #456961, #92b59d);
  font-family: "Digital-7 Mono", monospace;
  height: 80px;
  width: 1000px;
  border-radius: 10px;
  line-height: 80px;
  padding-left: 20px;
  border: 2px solid black;
  font-size: 20px;
  color: blanchedalmond;
}

.boards-outer-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.boards-container {
  display: flex;
  gap: 100px;
  justify-content: center;
  font-size: 1rem;
}

.board-title {
  background: linear-gradient(to right, red, yellow, orange);
  color: black;
  font-family: "Digital-7 Mono", monospace;
  text-align: center;
  border: 1px solid black;
  border-radius: 5px;
}

.grid-container {
  display: grid;
  grid-template-rows: repeat(10, 40px);
  grid-template-columns: repeat(10, 40px);
  background-color: white;
  border: 1px solid black;
  position: relative;
}

.grid-container > div {
  border: 1px solid black;
  position: relative;
}

.square {
  cursor: pointer;
  color: transparent;
  position: relative;
}

.dot {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-top: 10px;
  margin-left: 9px;
  position: absolute;
  z-index: 20;
}

.red-dot {
  background-color: red;
}

.black-dot {
  background-color: black;
}

#computer-dot {
  left: -2px;
  bottom: 8px;
}

.axis-button {
  background: #fff;
  backface-visibility: hidden;
  border-radius: 0.375rem;
  border-style: solid;
  border-width: 0.125rem;
  box-sizing: border-box;
  color: #212121;
  cursor: pointer;
  display: inline-block;
  font-family: Circular, Helvetica, sans-serif;
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.3;
  padding: 0.875rem 1.125rem;
  position: relative;
  text-align: left;
  text-decoration: none;
  transform: translateZ(0) scale(1);
  transition: transform 0.2s;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.axis-button:not(:disabled):hover {
  transform: scale(1.05);
}

.axis-button:not(:disabled):hover:active {
  transform: scale(1.05) translateY(0.125rem);
}

.axis-button:focus {
  outline: 0 solid transparent;
}

.axis-button:focus:before {
  content: "";
  left: -0.375rem;
  pointer-events: none;
  position: absolute;
  top: -0.375rem;
  transition: border-radius;
  user-select: none;
}

.axis-button:focus:not(:focus-visible) {
  outline: 0 solid transparent;
}

.axis-button:focus:not(:focus-visible):before {
  border-width: 0;
}

.axis-button:not(:disabled):active {
  transform: translateY(0.125rem);
}

.winner-container {
  position: absolute;
  background-color: #f0e6e6;
  border: 2px solid #333;
  height: 300px;
  width: 1000px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 300px;
  z-index: 30;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  padding: 20px;
}

.winner-display {
  background: linear-gradient(to right, #456961, #92b59d);
  height: 80px;
  width: 800px;
  border-radius: 10px;
  padding: 0 20px;
  border: 2px solid #333;
  line-height: 80px;
  color: blanchedalmond;
  font-size: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.highlight {
  background-color: #92b59d;
}

.ship-image {
  position: absolute;
  z-index: 1;
  width: 100px;
  height: auto;
  opacity: 0.4;
  top: -2px;
}

.vertical {
  transform: rotate(90deg);
  transform-origin: top left;
}

#ship1.vertical {
  left: 50px;
  bottom: 40px;
}

#ship2.vertical {
  left: 50px;
  bottom: 40px;
}

#ship3.vertical {
  left: 50px;
  bottom: 40px;
}

#ship4.vertical {
  left: 50px;
  bottom: 40px;
}

#ship5.vertical {
  left: 50px;
  bottom: 40px;
}

.computer-horizontal-ship {
  transform: translateX(-30px);
}

.hidden {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAQA;EACE,YAAA;EACA,aAAA;AALF;;AAUA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;AAPF;;AAUA;EACE,iBAAA;EACA,oBAAA;EACA,WAAA;EACA,SAAA;EACA,6BAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,uBAAA;EACA,6BAAA;AAPF;AAQE;EACE,YAAA;AANJ;AASE;EACE,iBAAA;EACA,YAAA;EACA,SAAA;AAPJ;;AAWA;EAUE,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2DAAA;EACA,qBAAA;AAjBF;AAIE;EACE,kBAAA;EACA,MAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAFJ;;AAYE;EAEE,gBAAA;AAVJ;;AAcA;EACE,kCAAA;EACA,aAAA;EACA,sBAAA;EAEA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;AAZF;;AAeA;EACE,WAAA;AAZF;;AAiBA;EACE,uDAAA;EACA,wCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;AAdF;;AAmBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,UAAA;EACA,uBAAA;EACA,eAAA;AAhBF;;AAmBA;EACE,0DAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,oCAAA;EACA,uCAAA;EAEA,uBAAA;EACA,uBAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,uBAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAjBF;;AAoBA;EACE,qBAAA;AAjBF;;AAoBA;EACE,uBAAA;AAjBF;;AAoBA;EACE,UAAA;EACA,WAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,4CAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,iCAAA;EACA,0BAAA;EACA,iBAAA;EACA,yBAAA;EACA,0BAAA;AAjBF;;AAoBA;EACE,sBAAA;AAjBF;;AAoBA;EACE,2CAAA;AAjBF;;AAoBA;EACE,4BAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;AAjBF;;AAoBA;EACE,4BAAA;AAjBF;;AAoBA;EACE,eAAA;AAjBF;;AAoBA;EACE,+BAAA;AAjBF;;AAsBA;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,wCAAA;EACA,aAAA;AAnBF;;AAsBA;EACE,uDAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wCAAA;AAnBF;;AAsBA;EACE,yBAAA;AAnBF;;AAwBA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;AArBF;;AAwBA;EACE,wBAAA;EACA,0BAAA;AArBF;;AAwBA;EACE,UAAA;EACA,YAAA;AArBF;;AAwBA;EACE,UAAA;EACA,YAAA;AArBF;;AAwBA;EACE,UAAA;EACA,YAAA;AArBF;;AAwBA;EACE,UAAA;EACA,YAAA;AArBF;;AAwBA;EACE,UAAA;EACA,YAAA;AArBF;;AAwBA;EACE,4BAAA;AArBF;;AAwBA;EACE,aAAA;AArBF","sourcesContent":[".content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n// TITLE IMAGE\r\n\r\n// .image-container {\r\n//   text-align: center;\r\n// }\r\n\r\n.title-image {\r\n  height: auto;\r\n  width: 1000px;\r\n}\r\n\r\n// FORM\r\n\r\n.form-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.player-name-input {\r\n  margin-top: 100px;\r\n  font-family: inherit;\r\n  width: 100%;\r\n  border: 0;\r\n  border-bottom: 2px solid gray;\r\n  outline: 0;\r\n  font-size: 2rem;\r\n  color: black;\r\n  padding: 7px 0;\r\n  background: transparent;\r\n  transition: border-color 0.2s;\r\n  &::placeholder {\r\n    color: black;\r\n  }\r\n\r\n  &:placeholder-shown ~ .player-name-label {\r\n    font-size: 1.3rem;\r\n    cursor: text;\r\n    top: 20px;\r\n  }\r\n}\r\n\r\n.player-name-input:focus {\r\n  ~ .player-name-label {\r\n    position: absolute;\r\n    top: 0;\r\n    display: block;\r\n    transition: 0.2s;\r\n    font-size: 1rem;\r\n    color: primary;\r\n    font-weight: 700;\r\n  }\r\n  padding-bottom: 6px;\r\n  font-weight: 700;\r\n  border-width: 3px;\r\n  border-image: linear-gradient(to right, primary, secondary);\r\n  border-image-slice: 1;\r\n}\r\n\r\n.player-name-input {\r\n  &:required,\r\n  &:invalid {\r\n    box-shadow: none;\r\n  }\r\n}\r\n\r\nbody {\r\n  font-family: \"Poppins\", sans-serif;\r\n  display: flex;\r\n  flex-direction: column;\r\n  // justify-content: center;\r\n  align-items: center;\r\n  min-height: 100vh;\r\n  font-size: 1.5rem;\r\n  background-color: white;\r\n}\r\n\r\n.player-name-button {\r\n  width: 50px;\r\n}\r\n\r\n// DISPLAY\r\n\r\n.display {\r\n  background: linear-gradient(to right, #456961, #92b59d);\r\n  font-family: \"Digital-7 Mono\", monospace;\r\n  height: 80px;\r\n  width: 1000px;\r\n  border-radius: 10px;\r\n  line-height: 80px;\r\n  padding-left: 20px;\r\n  border: 2px solid black;\r\n  font-size: 20px;\r\n  color: blanchedalmond;\r\n}\r\n\r\n// BOARDS\r\n\r\n.boards-outer-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.boards-container {\r\n  display: flex;\r\n  gap: 100px;\r\n  justify-content: center;\r\n  font-size: 1rem;\r\n}\r\n\r\n.board-title {\r\n  background: linear-gradient(to right, red, yellow, orange);\r\n  color: black;\r\n  font-family: \"Digital-7 Mono\", monospace;\r\n  text-align: center;\r\n  border: 1px solid black;\r\n  border-radius: 5px;\r\n}\r\n\r\n.grid-container {\r\n  display: grid;\r\n  grid-template-rows: repeat(10, 40px);\r\n  grid-template-columns: repeat(10, 40px);\r\n  // background-color: rgb(241, 240, 240);\r\n  background-color: white;\r\n  border: 1px solid black;\r\n  position: relative;\r\n}\r\n\r\n.grid-container > div {\r\n  border: 1px solid black;\r\n  position: relative;\r\n}\r\n\r\n.square {\r\n  cursor: pointer;\r\n  color: transparent;\r\n  position: relative;\r\n}\r\n\r\n.dot {\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 50%;\r\n  margin-top: 10px;\r\n  margin-left: 9px;\r\n  position: absolute;\r\n  z-index: 20;\r\n}\r\n\r\n.red-dot {\r\n  background-color: red;\r\n}\r\n\r\n.black-dot {\r\n  background-color: black;\r\n}\r\n\r\n#computer-dot {\r\n  left: -2px;\r\n  bottom: 8px;\r\n}\r\n\r\n.axis-button {\r\n  background: #fff;\r\n  backface-visibility: hidden;\r\n  border-radius: 0.375rem;\r\n  border-style: solid;\r\n  border-width: 0.125rem;\r\n  box-sizing: border-box;\r\n  color: #212121;\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  font-family: Circular, Helvetica, sans-serif;\r\n  font-size: 1.125rem;\r\n  font-weight: 700;\r\n  letter-spacing: -0.01em;\r\n  line-height: 1.3;\r\n  padding: 0.875rem 1.125rem;\r\n  position: relative;\r\n  text-align: left;\r\n  text-decoration: none;\r\n  transform: translateZ(0) scale(1);\r\n  transition: transform 0.2s;\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  touch-action: manipulation;\r\n}\r\n\r\n.axis-button:not(:disabled):hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.axis-button:not(:disabled):hover:active {\r\n  transform: scale(1.05) translateY(0.125rem);\r\n}\r\n\r\n.axis-button:focus {\r\n  outline: 0 solid transparent;\r\n}\r\n\r\n.axis-button:focus:before {\r\n  content: \"\";\r\n  left: calc(-1 * 0.375rem);\r\n  pointer-events: none;\r\n  position: absolute;\r\n  top: calc(-1 * 0.375rem);\r\n  transition: border-radius;\r\n  user-select: none;\r\n}\r\n\r\n.axis-button:focus:not(:focus-visible) {\r\n  outline: 0 solid transparent;\r\n}\r\n\r\n.axis-button:focus:not(:focus-visible):before {\r\n  border-width: 0;\r\n}\r\n\r\n.axis-button:not(:disabled):active {\r\n  transform: translateY(0.125rem);\r\n}\r\n\r\n// WINNER CONTAINER\r\n\r\n.winner-container {\r\n  position: absolute;\r\n  background-color: #f0e6e6;\r\n  border: 2px solid #333;\r\n  height: 300px;\r\n  width: 1000px;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-top: 300px;\r\n  z-index: 30;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n  padding: 20px;\r\n}\r\n\r\n.winner-display {\r\n  background: linear-gradient(to right, #456961, #92b59d);\r\n  height: 80px;\r\n  width: 800px;\r\n  border-radius: 10px;\r\n  padding: 0 20px;\r\n  border: 2px solid #333;\r\n  line-height: 80px;\r\n  color: blanchedalmond;\r\n  font-size: 1.5rem;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.highlight {\r\n  background-color: #92b59d;\r\n}\r\n\r\n// SHIP IMAGES\r\n\r\n.ship-image {\r\n  position: absolute;\r\n  z-index: 1;\r\n  width: 100px;\r\n  height: auto;\r\n  opacity: 0.4;\r\n  top: -2px;\r\n}\r\n\r\n.vertical {\r\n  transform: rotate(90deg);\r\n  transform-origin: top left;\r\n}\r\n\r\n#ship1.vertical {\r\n  left: 50px;\r\n  bottom: 40px;\r\n}\r\n\r\n#ship2.vertical {\r\n  left: 50px;\r\n  bottom: 40px;\r\n}\r\n\r\n#ship3.vertical {\r\n  left: 50px;\r\n  bottom: 40px;\r\n}\r\n\r\n#ship4.vertical {\r\n  left: 50px;\r\n  bottom: 40px;\r\n}\r\n\r\n#ship5.vertical {\r\n  left: 50px;\r\n  bottom: 40px;\r\n}\r\n\r\n.computer-horizontal-ship {\r\n  transform: translateX(-30px);\r\n}\r\n\r\n.hidden {\r\n  display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
